var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.displayClass)?_c('i',{class:( _obj = {'icon': true}, _obj[_vm.displayClass] = true, _obj[_vm.iconSize] = true, _obj )}):_vm._e(),_vm._v(" "+_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }